import { ApplicationConfig, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { NgxPermissionsModule } from "ngx-permissions";

import { environment } from '../environments/environment';

// Firebase
import { provideFirebaseApp, initializeApp } from '@angular/fire/app';
import { provideMessaging, getMessaging } from '@angular/fire/messaging';

// Interceptors
import { authInterceptor } from './auth/interceptors/auth.interceptor';
import { errorInterceptor } from './auth/interceptors/error.interceptor';

// Providers
import { userServiceProvider } from './users/services/user-service.provider';
import { groupServiceProvider } from './groups/services/group-service.provider';
import { provideMarkdown } from 'ngx-markdown';

// TAS Search Library
import { provideTasLib } from 'aisearch-search-fe-library';

import { routes } from './app.routes';


export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes, withComponentInputBinding()),
    provideHttpClient(withInterceptors([authInterceptor, errorInterceptor])),
    // Import providers from NgxPermissionsModule
    importProvidersFrom(NgxPermissionsModule.forRoot()),
    provideFirebaseApp(() => initializeApp(environment.firebase)),
    provideMessaging(() => getMessaging()),
    // 👇 i provider con factory che scelgono fra reale e demo
    userServiceProvider,
    groupServiceProvider,
    provideMarkdown(),
    ...provideTasLib({
      apiUrl: environment.searchUrl + '/api/search/preview',
      apiUrlStream: environment.searchUrl + '/api/stream/preview',
      apiUrlStreamGet: environment.searchUrl + '/api/gstream/preview'
    },)
  ]
};
